import React from 'react';
import type { CardMediaProps } from '@mui/material';
import { CardMedia, Box } from '@mui/material';
import { styled } from '@mui/system';

interface CustomCardMediaProps extends CardMediaProps {
  mediaType?: 'image' | 'video';
  videoSrc?: string;
  videoControls?: boolean;
  imageUrl?: string;
  imgAlt?: string;
  imgTagSrc?: string;
  imgHeight?: string;
}

const MediaContainer = styled(Box)({
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
});

const CustomCardMedia: React.FC<CustomCardMediaProps> = ({
  mediaType = 'image',
  videoSrc,
  videoControls = true,
  imageUrl,
  imgAlt,
  imgTagSrc,
  imgHeight,
  ...props
}) => {
  const renderImage = () => {
    if (imgTagSrc) {
      return (
        <img
          src={imgTagSrc}
          alt={imgAlt}
          style={{ width: '100%', height: imgHeight ?? '150px' }}
        />
      );
    } else if (imageUrl) {
      return (
        <CardMedia
          component="img"
          height={imgHeight ?? '150px'}
          image={imageUrl}
          alt={imgAlt}
        />
      );
    } else {
      return null;
    }
  };
  return (
    <MediaContainer>
      {mediaType === 'image' ? (
        renderImage()
      ) : (
        <CardMedia
          component="video"
          src={videoSrc}
          controls={videoControls}
          {...props}
        />
      )}
    </MediaContainer>
  );
};

export default CustomCardMedia;
